
$(document).ready(function(){
  	$.get("https://ipinfo.io/json", function (response) {
      const regionNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'region' });
      console.log(regionNamesInEnglish.of(response.country));
      $(".country-name").text(regionNamesInEnglish.of(response.country));
          	if (!sessionStorage.getItem("checkedPopup")) {                
              if (sessionStorage.getItem("checkedPopup") == 1) {
              	
              }else {
              	sessionStorage.setItem("checkedPopup", "1");
                 $("#location-popup").lightbox_me( { centered: true } );  
              }
            }
    });
       
    $(".location_btn").click(function(e){
      e.preventDefault();
      if($(this).hasClass('uk')){
        $('#location-popup .close').click();
      } else {
        window.location.replace($(this).attr('href'));
      }      
    })
    $("body").click(function(e){
      // e.preventDefault();
      console.log("111s");
      if($(e.target).closest('#location-popup').length != 0) return false;
      // $('#location-popup .close').click();
    });
  })


$(document).ready(function() {

  $("body").on('click', '.pick_currency .list li.option', function(event) {
        var DataValue = $(this).data('value');
        
        if (DataValue === 'USD' || DataValue === 'CAD') {
            event.stopPropagation();
            
            var currentUrl = window.location.href;
            var newUrl = currentUrl.replace(window.location.origin, 'https://corkspace.com');
            
            var url = new URL(newUrl);
            var params = new URLSearchParams(url.search);
              
            // Check if there are already query parameters
            if(params.toString()) {
                // If query parameters exist, use & to append new parameter
                params.append('currencycode', DataValue);
                url.search = params.toString();
            } else {
                // If no query parameters, use ? to start the query string
                url.search = '?currencycode=' + DataValue;
            }
           
           window.location.href = url.toString();
        }
    });

  
  var currencyHTML = `
    <a class="pick_currency mldesk" style="">
      <div class="nice-select" tabindex="0">
        <span class="circle circle-gbp flags current-flags flag-icon"></span>
        <span class="mlcurrent flag-icon">GBP</span>
        <ul class="list">
         <li class="option" data-value="CAD">
            <span class="circle circle-cad flags"></span>
            <span class="cn">CAD</span>
          </li>
          <li class="option" data-value="USD">
            <span class="circle circle-usd flags"></span>
            <span class="cn">USD</span>
          </li>
          <li class="option" data-value="GBP">
            <span class="circle circle-gbp flags"></span>
            <span class="cn">GBP</span>
          </li>
        </ul>
      </div>
     <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</path></svg>
    </a>
  `;

  $('header.header .header__icons').append(currencyHTML);
$('.menu-drawer__navigation > .menu-drawer__menu').prepend(currencyHTML);


  $("body").on('click', '.flag-icon', function() {
   
    $(this).closest('.nice-select').toggleClass('open');
    
  });

  $("body").on('click', '.pick_currency .list .option', function() {
    var selectedValue = $(this).data('value'); 
    var selectedText = $(this).find('.cn').text(); 

    // Update the current flag and text
    $('.current-flags').attr('class', 'circle circle-' + selectedValue.toLowerCase() + ' flags current-flags');
    $('.mlcurrent').text(selectedText);

    $(this).closest('.nice-select').removeClass('open');
    $('.header__icons').show(); 
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const variantRadios = document.querySelectorAll('input[name="Print"]');
    const modalOpener = document.querySelector(".product__modal-opener");

    function updateCSS() {
        const selectedRadio = document.querySelector('input[name="Print"]:checked');

        if (selectedRadio && selectedRadio.value === "None") {
            modalOpener.classList.add("show-trusted-badge");
        } else {
            modalOpener.classList.remove("show-trusted-badge");
        }
    }

    variantRadios.forEach(radio => {
        radio.addEventListener("change", function () {
            setTimeout(updateCSS, 10); // Small delay to ensure proper detection
        });
    });

    // Initial check on page load
    updateCSS();
});


